// Kyte branded-fare upsell — POST kyte.bundles. Bundles ship a new offerId
// per variant but NOT the flightSolutions / legs / segments — those stay
// with the original shop-flights offer, so we re-attach them here before
// normalizing. The `_provider: 'kyte'` tag keeps provider-dispatch
// (apply_seats / reprice / book) resolving to KyteProvider after a bundle
// is committed as the selected offer.

import { service_handler } from '@/services'
import { log } from '@/utilities/commons'
import { strip_offer_additional_services } from '@liveflight/utilities/additional-services'
import { normalize } from './normalize'
import { unwrap } from './helpers'

// `legs` is only copied through when the base actually had one; an explicit
// `undefined` key still serializes and breaks deep-equality in tests.
const build_bundle_raw = (base_raw, bundle) => {
  const { flightSolutions = [], legs } = base_raw || {}
  const raw = {
    ...bundle,
    _provider: 'kyte',
    flightSolutions,
  }
  if (legs) {
    raw.legs = legs
  }
  return raw
}

export const fetch_upsell = (provider, flight_offer) => {
  const body = {
    shopBundlesRequest: {
      offerIds: [flight_offer.providerOfferId],
    },
  }
  return service_handler('kyte.bundles', body, { modal: false }).then((response) => {
    const envelope = unwrap(response) || {}
    const offers = envelope.offers || {}
    const base_raw = flight_offer._raw || {}
    // Per-entry try/catch so one malformed bundle (failing validate inside
    // normalize) doesn't wipe the entire upsell list — same resilience
    // pattern as providers/index.js search_all.
    const variants = Object.keys(offers).reduce((acc, offer_id) => {
      try {
        const raw = build_bundle_raw(base_raw, offers[offer_id])
        acc.push(normalize(provider, raw))
      } catch (e) {
        log(`[kyte/upsell] dropping bundle ${offer_id}: ${e.message}`)
      }
      return acc
    }, [])
    // Strip the original offer's committed ancillaries before prepending:
    // bundles ship at the BASE fare price (no ancillaries on variant rows),
    // so committed seats / bags would make the comparison apples-to-oranges.
    return [strip_offer_additional_services(flight_offer), ...variants]
  })
}
